import { charityStatusMap } from '../../../../../lib/charity'
import { localDate } from '../../../../../lib/date'
import { campaignStatusMap } from '../../../../../lib/campaign'
import { CharityPreview } from './preview/CharityPreview'
import React, { type FunctionComponent } from 'react'

type Props = {
  data: CharityReportType[]
}

export const CharityReportTable: FunctionComponent<Props> = ({ data }) => {
  return data.length > 0 ? (
    <table className="table-auto text-left w-full">
      <thead>
        <tr className="*:text-sm *:py-sm *:px-md">
          <th>Display name</th>
          <th>Charity status</th>
          <th className="!text-right">Created</th>
          <th>Campaign</th>
          <th className="!text-right">Start date</th>
          <th className="!text-right">End date</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {data.map((d, i) => {
          const { charity, campaign } = d

          return (
            <tr key={`${i}-${charity.id}`} className="odd:bg-[rgba(0,0,0,0.05)] align-text-top *:p-md *:text-sm">
              <td>{charity.organization.displayName}</td>
              <td>{charity.note || charityStatusMap[charity.status]}</td>
              <td className="!text-right">{localDate(charity.createdAt as string)}</td>
              <td>{campaign?.name || '-'}</td>
              <td className="!text-right">{campaign?.startTime ? localDate(campaign?.startTime) : '-'}</td>
              <td className="!text-right">{campaign?.endTime ? localDate(campaign?.endTime) : '-'}</td>
              <td>{campaign ? campaignStatusMap[campaign.status as CampaignStatusType] : '-'}</td>
              <td>
                <CharityPreview data={d} />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  ) : (
    <div className="p-md">No charities matched your filter</div>
  )
}
